// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"AboutParagraph_bodyText__zcNgx","paragraph":"AboutParagraph_paragraph__SRUvk"};